import { render, staticRenderFns } from "./declareSample.vue?vue&type=template&id=300fb2ea&scoped=true&"
import script from "./declareSample.vue?vue&type=script&lang=js&"
export * from "./declareSample.vue?vue&type=script&lang=js&"
import style0 from "./declareSample.vue?vue&type=style&index=0&id=300fb2ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300fb2ea",
  null
  
)

export default component.exports